// ABOUTME: Main chat interface page using assistant-ui components
// ABOUTME: Features LangGraph runtime with thread management and streaming

import { Thread } from "@/components/assistant-ui/thread";
import { ChatRuntimeProvider } from "@/providers/ChatRuntimeProvider";
import { Neo4jQueryToolUI, SchemaToolUI, RecommendationsQueryToolUI, RecommendationsSchemaToolUI } from "@/components/assistant-ui/tool-ui";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";

export function ChatPage() {
  const { user } = useAuth();

  const handleNewConversation = () => {
    // Clear thread ID from localStorage to start fresh
    localStorage.removeItem("current_thread_id");
    // Reload the page to reinitialize the runtime
    window.location.reload();
  };

  // Only leads, exco, and admins should see this page
  const allowedRoles = ['leads', 'exco', 'admin'];
  if (!user?.role || !allowedRoles.includes(user.role)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-2">Access Denied</h1>
          <p className="text-gray-600">You do not have permission to access this page.</p>
          <p className="text-sm text-gray-500 mt-2">Only leads and exco can access the chat.</p>
        </div>
      </div>
    );
  }

  return (
    <ChatRuntimeProvider>
      <div className="flex flex-col h-full">
        {/* WIP Banner */}
        <div className="bg-yellow-50 border-b-2 border-yellow-400 px-6 py-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <span className="text-2xl">🚧</span>
              <div>
                <h2 className="text-lg font-bold text-yellow-900">Work in Progress</h2>
                <p className="text-sm text-yellow-800">
                  This chat interface is currently under construction. Features may be incomplete or subject to change.
                </p>
              </div>
            </div>
            <Button
              onClick={handleNewConversation}
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
            >
              <PlusIcon className="h-4 w-4" />
              New Conversation
            </Button>
          </div>
        </div>

        {/* Main chat interface */}
        <div className="flex-1 overflow-hidden">
          <Thread />
        </div>
      </div>

      {/* Tool UIs - Must be placed at root level inside AssistantRuntimeProvider */}
      <Neo4jQueryToolUI />
      <SchemaToolUI />
      <RecommendationsQueryToolUI />
      <RecommendationsSchemaToolUI />
    </ChatRuntimeProvider>
  );
}
